import { useState } from 'react';
import ProductModal from '../ProductModal';
import { useProductCardContext } from '../../context/ProductCardContext';
import { TRACKING_PROPERTIES } from '../../../custom-hooks/useProductSnowplowTracking';
import { SELECTBOX_VALUE } from '../../utils/selectBoxOptions';
import CustomSelectBox from './CustomSelectBox';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CustomSelectBoxWithModal = ({
  CustomLabel,
  CustomOptions,
  className
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    extraProps,
    productName
  } = useProductCardContext();
  const {
    formattedOptions,
    isPersuasionModalEnabled,
    options,
    onModalConfirm,
    setSelectedOptions,
    sendAddToCartEvent,
    sendSnowplowTracking,
    translation,
    updateContext
  } = extraProps;
  const {
    persuasionContent,
    title
  } = translation;
  const handleModalConfirmation = async () => {
    const confirmationValues = formattedOptions.filter(({
      value
    }) => value !== 'NONE');
    if ((confirmationValues === null || confirmationValues === void 0 ? void 0 : confirmationValues.length) > 0) {
      setSelectedOptions(confirmationValues);
      onModalConfirm(confirmationValues);
      await updateContext({
        quantity: options.length
      });
      sendAddToCartEvent({
        addToCart: true,
        property: TRACKING_PROPERTIES.VALIDATION_POP_UP
      });
    }
    setIsModalOpen(false);
  };
  const handleModalDecline = () => {
    sendAddToCartEvent({
      addToCart: false,
      property: TRACKING_PROPERTIES.VALIDATION_POP_UP
    });
    setIsModalOpen(false);
  };
  const handleModalOpen = selectedOption => {
    const shouldOpenModal = isPersuasionModalEnabled && selectedOption.find(option => option.value === SELECTBOX_VALUE.NONE);
    if (shouldOpenModal) {
      setIsModalOpen(true);
    }
  };
  const handleOptionClick = (event, option) => {
    sendSnowplowTracking(event, option, formattedOptions, options, updateContext, sendAddToCartEvent);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CustomSelectBox, {
      CustomLabel: CustomLabel,
      CustomOptions: CustomOptions,
      className: className,
      onModalOpen: handleModalOpen,
      onOptionClick: handleOptionClick
    }), /*#__PURE__*/_jsx(ProductModal, {
      content: persuasionContent,
      isOpen: isModalOpen,
      onConfirm: handleModalConfirmation,
      onDecline: handleModalDecline,
      productName: productName,
      title: title
    })]
  });
};
export default CustomSelectBoxWithModal;
//# sourceMappingURL=CustomSelectBoxWithModal.js.map